// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Video_video__36Lug {\n  width: 100%;\n  box-shadow: var(--landing-box-shadow);\n}\n.Video_video__36Lug video {\n  display: block;\n}\n", "",{"version":3,"sources":["webpack://src/Landing/Includes/Video.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB","sourcesContent":[".video {\n  width: 100%;\n  box-shadow: var(--landing-box-shadow);\n}\n.video video {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video": "Video_video__36Lug"
};
export default ___CSS_LOADER_EXPORT___;
